import React from 'react';
import { CnLayoutRow as UICnLayoutRow } from "../../components/cn-layout";
var CnLayoutRow = function CnLayoutRow(props) {
  var _ref = props || {},
    children = _ref.children;
  return /*#__PURE__*/React.createElement(UICnLayoutRow, null, children);
};
CnLayoutRow.displayName = 'CnLayoutRow';
export default CnLayoutRow;
export { CnLayoutRow };